<template>
    <div>
        <div class="step-content call-to-data">
            <div class="call-to-actions">
                <div
                    class="btn-outline btn-outline-delete"
                    @click="openDeleteDialog"
                    style="margin-right: auto"
                >
                    <img src="/img/delete_red.svg" style="transform: scale(1.05); margin-right: 8px" class="img-delete"
                         alt="icon-delete">
                    {{ $f.tc('clearData')}}
                </div>
                <div class="btn-outline" @click="$refs.customerDialog.open()">
                    <img src="/img/add-blue.svg" style="transform: scale(1.25); margin-right: 8px" alt="icon-add">
                    {{ $f.tc('addCustomer') }}
                </div>
                <div class="btn-outline" @click="$refs.generalInfoDialog.open()">
                    <img src="/img/setting.svg" style="transform: scale(1.1); margin-right: 8px" alt="icon-setting">
                    {{ $f.tc('customerProperties') }}
                </div>
                <div class="btn-outline" @click="openUploadDialog">
                    <img src="/img/upload.svg" style="transform: scale(1.05); margin-right: 8px" alt="icon-upload">
                    {{ $f.tc('uploadFileData') }}
                </div>
            </div>
            <div class="flexbox table-form flex-justify-content-end customer-form-filter" style="padding: 12px">
                <div class="flexbox filter-form">
                    <TimeRangePicker ref="TimeRangePicker" v-model="timeRange"></TimeRangePicker>
                    <!--Filter name-->
                    <div style="width: 250px; margin-left: 8px">
                        <v-text-field
                            hide-details outlined
                            v-model="filter.name"
                            placeholder="Customer Name"
                            class="input-custom"
                            @keyup.enter="loadData(1, false, false)"
                        ></v-text-field>
                    </div>
                    <!--Filter phone-->
                    <div style="width: 250px; margin-left: 8px">
                        <v-text-field
                            hide-details outlined
                            v-model="filter.phone"
                            placeholder="Customer Phone"
                            class="input-custom"
                            @keyup.enter="loadData(1, false, false)"
                        >
                            <template slot="append" v-if="encryptAndMask">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-icon v-on="on" style="margin-top: -6px;scale: 0.8;color: #e3a008">
                                            mdi-information
                                        </v-icon>
                                    </template>
                                    <span>{{ $f.tc('searchEncryptedCustomer') }}</span>
                                </v-tooltip>
                            </template>
                        </v-text-field>
                    </div>
                    <!--Filter status-->
                    <div style="width: 250px; margin-left: 8px">
                        <v-select
                            hide-details outlined
                            v-model="filter.status"
                            placeholder="Status"
                            :items="statusData"
                            @change="loadData(1, false, false)"
                            class="input-custom"
                            item-value="key"
                            item-text="value"
                        ></v-select>
                    </div>
                    <div
                        class="ml-8"
                        :class="isLoadingRefresh ? 'btn-disable' : 'btn-custom'"
                        @click="loadData(1, false, false)"
                    >
                        <v-progress-circular
                            indeterminate
                            width="3"
                            color="grey"
                            class="mr-6"
                            style="width: 16px"
                            v-if="isLoadingRefresh"
                        ></v-progress-circular>
                        <v-icon v-else style="margin-right: 6px; color: #FFFFFF; width: 16px">mdi-filter-outline
                        </v-icon>
                        {{ $f.tc('filter') }} / {{ $f.tc('refresh') }}
                    </div>
                </div>
            </div>
            <div class="call-to-table-wrap fci-scrollbar">
                <div class="call-to-table-data clearfix">
                    <div v-if="dataTable.length" :key="tableKey" class="display-flex">
                        <div v-for="(table, index) in dataTable"
                             :key="index"
                             :class="[{ 'customer-info': index === 0 }, { 'general-info': index === 1 }, 'call-to-table-' + (index + 1)] ">
                            <SimpleDataTable
                                v-if="index === 0"
                                :table-title="table.title"
                                :headers="customerPhoneHeader([...table.headers, ...actionsHeader])"
                                :items="table.data"
                                :config-column="true"
                                :hide-pager="true"
                                :current-page="currentPage"
                                :total-page="totalPage"
                                :items-per-page="itemPerPage"
                                :total-items="totalItems"
                                :sort-by="sortBy"
                                :sort-direction="sortDirection"
                                @sort-change="loadData(false, false, $event)"
                                :keep-desktop-layout="true"
                                :add-index="true"
                                :selectable="canEdit(campaign.permissions)"
                                @selection-data="onSelection($event)"
                                :selected-prop="defaultSelected"
                            >
                                <!-- Custom bottom bar -->
                                <template v-slot:selection-actions>
                                    <div
                                        v-if="enableZalo"
                                        class="btn-custom"
                                        @click="$refs.massRequestConsentZaloDialog.open(selectionData)"
                                    >
                                        Mass request consent Zalo ({{ selectionData.length }})
                                    </div>
                                    <div class="btn-custom" @click="$refs.massCallingDialog.open(selectionData)">
                                        {{ $f.tc('massCalling') }} ({{ selectionData.length }})
                                    </div>
                                    <div class="btn-danger" @click="deleteSelectedCustomer">
                                        {{ $f.tc('deleteSelected') }} ({{ selectionData.length }})
                                    </div>
                                </template>

                                <!-- Custom actions row -->
                                <template v-slot:customStatus="props">
                                    <div class="centerXY">
                                        <div
                                            class="status-val"
                                            :style="{background: $utils.getStatusColor(props.item['customStatus']), paddingRight: props.item['times_of_call'] && props.item['times_of_call'] >=2 ? '6px' : '10px'}"
                                        >
                                            {{ props.item['customStatus'] }}
                                            <v-tooltip right color="#6E6E6E" close-delay="600">
                                                <template v-slot:activator="{ on }">
                                                    <img
                                                        v-if="props.item['times_of_call'] && props.item['times_of_call'] >=2"
                                                        v-on="on"
                                                        src="/img/help-circle.svg" alt="icon-more-info"
                                                        style="width: 20px; margin-bottom: 1px"
                                                        class="ml-6"
                                                        @click.stop="getCustomerStatus(props.item.id)"
                                                    >
                                                </template>
                                                <table
                                                    v-if="checkCustomerStatus(props.item.id)"
                                                    class="additional-data"
                                                >
                                                    <thead>
                                                    <tr>
                                                        <td>Phone number</td>
                                                        <td class="text-center">Status</td>
                                                        <td>Start time</td>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="item in checkCustomerStatus(props.item.id).data" :key="item.id">
                                                        <td>{{ item["phone_number"] }}</td>
                                                        <td class="centerXY">
                                                            <div
                                                                style="color: #fff; padding: 2px 8px; border-radius: 15px"
                                                                :style="{background: $utils.getStatusColor(item['status'])}"
                                                            >
                                                                {{ item["status"] }}
                                                            </div>
                                                        </td>
                                                        <td>{{ item["start_time"] }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                <span v-else style="color: #fff">{{ $f.tc('allCustomerStatus') }}</span>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:actions="props">
                                    <span class="row-actions">
                                        <v-icon
                                            v-if="enableZalo"
                                            small
                                            class="action-icon"
                                            @click.stop="$refs.requestConsentZaloDialog.open(props.item)">mdi-send
                                        </v-icon>
                                        <v-icon
                                            small
                                            class="action-icon"
                                            @click.stop="customOpenDialogPhone(props.item)">mdi-phone</v-icon>
                                        <v-icon
                                            small
                                            class="action-icon"
                                            @click.stop="customOpenDialogEdit(props.item)">edit</v-icon>
                                        <v-icon
                                            small
                                            class="action-icon mr-0"
                                            @click="customerToDelete = props.item; $refs.confirmDelete.open('customer', props.item.name)">delete</v-icon>
                                    </span>
                                </template>

                                <!-- Custom field phone number -->
                                <template v-slot:phone_number="props">
                                    <div v-if="props.item.phone_numbers.length <= 2">
                                        <span v-for="phone in props.item.phone_numbers" :key="phone.phone_number">
                                        {{ phone.phone_number }} <br>
                                        </span>
                                    </div>
                                    <div v-if="props.item.phone_numbers.length > 2">
                                        <div class="d-flex align-center">
                                            {{ props.item.phone_numbers[0].phone_number }}
                                            <v-menu
                                                offset-y
                                            >
                                                <template v-slot:activator="{ attrs, on }">
                                                    <v-icon class="icon-menu" v-bind="attrs" v-on="on" size="23">
                                                        mdi-menu-down
                                                    </v-icon>
                                                </template>
                                                <div class="fci-list">
                                                    <div class="fci-list-item"
                                                         v-for="(phone, idx) in props.item.phone_numbers"
                                                         :key="idx"
                                                    >
                                                        {{ phone.phone_number }}
                                                    </div>
                                                </div>
                                            </v-menu>
                                        </div>
                                    </div>
                                </template>
                            </SimpleDataTable>
                            <data-table-with-tab-nav
                                v-if="index === 1"
                                :tab-title="table.title"
                                :data-table="table.data"
                                :data-headers="table.headers"
                                :columns-per-tab="4"
                                :default-tab="1"
                                :hide-pager="true"
                                :keep-desktop-layout="true">
                            </data-table-with-tab-nav>
                        </div>
                    </div>
                </div>
            </div>
            <SimpleDataTable
                :headers="[]"
                :items="[]"
                :current-page="currentPage"
                :total-page="totalPage"
                :items-per-page="itemPerPage"
                :total-items="totalItems"
                @page-change="loadData($event, false, false)"
                @item-per-page-change="loadData(1, $event, false)"
            >
            </SimpleDataTable>
        </div>
        <div class="step-actions" v-if="isStep">
            <div v-if="canGoBack" @click="goBack" class="btn-custom btn-back">
                {{ backTitle || $f.tc('back') }}
            </div>
            <div v-if="canNext" @click="submit" class="btn-custom">
                {{ nextTitle || $f.tc('next') }}
            </div>
            <div v-if="isEdit || !canNext" @click="submit($event, true)" class="btn-custom">
                {{ $f.tc('save') }}
            </div>
        </div>
        <campaign-add-customer
            @done="loadData(false, false, false, false, true)"
            ref="customerDialog"
        ></campaign-add-customer>
        <CampaignCustomerProperties
            @close="loadData(false, false, false)"
            :unique-editable="dataTable && dataTable[0] && dataTable[0].data.length === 0"
            ref="generalInfoDialog"
        ></CampaignCustomerProperties>
        <call-now-dialog
            ref="callNowDialog"
            @success="loadData(false, false, false)"
        ></call-now-dialog>
        <request-consent-zalo-dialog
            ref="requestConsentZaloDialog"
            @success="loadData(false, false, false)"
        ></request-consent-zalo-dialog>
        <confirm-delete-dialog
            :title="$f.tc('confirm')"
            ref="confirmDelete"
            @disagree="customerToDelete = false;loadData(false, false, false)"
            @agree="removeCustomer()"></confirm-delete-dialog>
        <campaign-mass-calling
            ref="massCallingDialog"
            @success="loadData(false, false, false)"
            @on-close="defaultSelected = []; selectionData = []"
        ></campaign-mass-calling>
        <campaign-mass-request-consent-zalo
            ref="massRequestConsentZaloDialog"
            @success="loadData(false, false, false)"
            @on-close="defaultSelected = []; selectionData = []"
        ></campaign-mass-request-consent-zalo>
        <UploadDataFileDialog ref="UploadDataFileDialog" :campaign="campaign"></UploadDataFileDialog>
        <ConfirmDeleteCustomer
            ref="ConfirmDeleteCustomer"
            @close="loadData(false, false, false)"
        ></ConfirmDeleteCustomer>
        <ConfirmDeleteCustomerFromTo
            ref="ConfirmDeleteCustomerFromTo"
            :filter="filter"
            @close="loadData(false, false, false)"
        ></ConfirmDeleteCustomerFromTo>
    </div>
</template>
<script>
import SimpleDataTable from '@/components/SimpleDataTable'
import ConfirmDeleteDialog from '@/components/ConfirmDeleteDialog'
import DataTableWithTabNav from '@/views/Campaign/DataTableWithTabNav'
import CampaignAddCustomer from './Step3/CampaignAddCustomer'
import CampaignCustomerProperties from './Step3/CampaignCustomerProperties.vue'
import CampaignMassCalling from './CampaignMassCalling'
import CallNowDialog from './Step3/CallNowDialog'
import CampaignService from '@/services/campaign.service'
import {mapState} from 'vuex'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import UploadDataFileDialog from "@/views/Campaign/Form/Step3/UploadDataFileDialog"
import ConfirmDeleteCustomer from "@/views/Campaign/Form/Step3/ConfirmDeleteCustomer"
import RequestConsentZaloDialog from "@/views/Campaign/Form/Step3/RequestConsentZaloDialog"
import CampaignMassRequestConsentZalo from "@/views/Campaign/Form/CampaignMassRequestConsentZalo"
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker'
import ConfirmDeleteCustomerFromTo from "@/views/Campaign/Form/Step3/ConfirmDeleteCustomerFromTo";

export default {
    name: 'NewCampaignStep3',
    components: {
        TimeRangePicker,
        RequestConsentZaloDialog,
        SimpleDataTable,
        ConfirmDeleteDialog,
        DataTableWithTabNav,
        CampaignAddCustomer,
        CampaignCustomerProperties,
        CampaignMassCalling,
        CampaignMassRequestConsentZalo,
        CallNowDialog,
        UploadDataFileDialog,
        ConfirmDeleteCustomer,
        ConfirmDeleteCustomerFromTo
    },
    mixins: [RoleMixin],
    props: {
        next: Function,
        nextTitle: String,
        canNext: Boolean,
        back: Function,
        canGoBack: Boolean,
        backTitle: String,
        campaign: Object,
        isStep: Boolean,
    },
    data() {
        let today = this.$moment().format('YYYY-MM-DD')
        return {
            enableZalo: '',
            customers: false,
            statusData: [],
            filter: {
                name: '',
                phone: '',
                status: '',
                from_date: today,
                from_time: '00:00:00',
                to_date: today,
                to_time: '23:59:59'
            },
            tableKey: 0,
            dataTable: [],
            currentPage: 1,
            totalPage: 1,
            itemPerPage: this.$const.itemPerPage,
            totalItems: 0,
            sortBy: 'name',
            sortDirection: this.$const.sortDirection,
            currentSort: 'name',
            customerToDelete: false,
            actionsHeader: [
                {
                    text: 'Actions',
                    sortable: false,
                    invisible: false,
                    type: 'custom',
                    value: 'actions',
                    id: 'actions',
                    center: true
                }
            ],
            defaultSelected: [],
            selectionData: [],
            timeRange: 'today',
            isLoadingRefresh: false,
            encryptAndMask: this.campaign.encrypt_and_mask ? this.campaign.encrypt_and_mask : false,
            customerStatusList: [],
        }
    },
    computed: {
        ...mapState({
            dataLoading: state => state.isDataLoading,
            isEdit: state => state.campaign.isEdit,
            isAdminOrOwner: () => CampaignService.isAdminOrOwner(),
        })
    },
    mounted() {
        this.loadData(1, false, false)
        this.getStatus()
        this.getConfigs()
    },
    methods: {
        getStatus() {
            CampaignService.getCustomerStatus().then(res => {
                if (res.data.length) {
                    this.statusData = [
                        {
                            key: '',
                            value: 'All Status'
                        },
                        ...res.data
                    ]
                }
            })
        },
        getConfigs() {
            if (this.isAdminOrOwner) {
                let campaignId = this.campaign.id ? this.campaign.id : this.$route.params.campaignId
                CampaignService.getConfigs(campaignId).then(res => {
                    this.enableZalo = (res.data['zalo_config'] === true);
                })
            }
        },
        customerPhoneHeader(headers) {
            return headers.map(header => {
                if (header.value === 'phone_number') {
                    return {
                        ...header,
                        type: 'custom',
                        id: 'phone_number'
                    }
                }
                if (header.value === 'times_of_call') {
                    return {
                        ...header,
                        id: 'times_of_call',
                        center: true
                    }
                }

                if (header.value === 'customStatus') {
                    return {
                        ...header,
                        center: true
                    }
                }
                return header
            })
        },
        loadData(page, itemsPerPage, sortOptions) {
            if (this.isLoadingRefresh) {
                return
            }

            if (!page) {
                page = this.currentPage
            }

            this.itemPerPage = itemsPerPage ? itemsPerPage : this.itemPerPage
            this.isLoadingRefresh = true
            this.$appService.dataLoading(true)
            let sort = this.currentSort
            if (sortOptions) {
                sort = sortOptions.direction === 'desc' ? sortOptions.value : '-' + sortOptions.value
            }

            CampaignService.getCustomers(this.campaign, this.itemPerPage, page, sort, this.filter).then(res => {
                this.customers = res.data
                this.dataTable = []
                this.totalItems = res.data.count || res.data.total
                this.totalPage = Math.ceil(this.totalItems / this.itemPerPage)
                this.currentPage = page
                this.currentSort = res.data['ordering']
                if (this.currentSort.indexOf('-') > -1) {
                    this.sortDirection = 'desc'
                } else {
                    this.sortDirection = 'asc'
                }

                this.sortBy = res.data['ordering'].replace(/-/g, '')
                res.data.header.map(header => {
                    header.children = this.$utils.reFormatHeaderTable(header.children)
                    let dataArr = []
                    res.data.data.map(data => {
                        dataArr.push(data[header.value])
                    })
                    this.dataTable.push({
                        title: header.text,
                        headers: header.children,
                        data: dataArr
                    })
                })

                this.$nextTick().then(() => {
                    this.tableKey += 1
                })
            }).finally(() => {
                this.$appService.dataLoading(false)
                this.isLoadingRefresh = false
            })
        },
        removeCustomer() {
            this.$appService.dataLoading(true)
            CampaignService.removeCustomer(this.campaign, this.customerToDelete).then(() => {
                this.customerToDelete = false
                this.loadData(false, false, false)
            })
        },
        submit(event, done) {
            if (event) {
                event.preventDefault()
            }

            if (typeof this.next === 'function') {
                this.next(done)
            }
        },
        goBack() {
            if (typeof this.back === 'function') {
                this.back()
            }
        },
        onSelection(items) {
            this.selectionData = [...items]
        },
        openUploadDialog() {
            this.$refs.UploadDataFileDialog.open().then(
                () => this.loadData(false, false, false)
            )
        },
        deleteSelectedCustomer() {
            this.$refs.ConfirmDeleteCustomer.open(this.selectionData).then(
                () => this.loadData(false, false, false)
            )
        },
        openDeleteDialog() {
            this.$refs.ConfirmDeleteCustomerFromTo.open(this.campaign, this.$refs.TimeRangePicker.getTimestamp()).then(
                () => this.loadData(false, false, false)
            )
        },
        customOpenDialogPhone(customer) {
            let status = customer.customStatus
            let phoneNumbers = customer.phone_numbers
            let isDigit = true
            for (let phone of phoneNumbers) {
                let lastFour = phone.phone_number.slice(-4);
                // Regular expression to check if all are digits
                isDigit = /^\d{4}$/.test(lastFour);
                if (!isDigit) {
                    break
                }
            }
            if (!isDigit) {
                this.$appService.toastWarning(this.$f.tc("warningMaskPhoneNumber"))
            } else if (status === 'In Progress') {
                this.$appService.toastWarning(this.$f.tc("warningInProgressCustomer"))
                this.loadData(1, false, false)
            } else {
                this.$refs.callNowDialog.open(customer)
            }
        },
        checkCustomerStatus(customerId) {
            if (!customerId) {
                return false
            }
            return this.customerStatusList.find(i => i.id === customerId);
        },
        getCustomerStatus(customerId) {
            if (!this.checkCustomerStatus(customerId)) {
                CampaignService.allCustomerStatus(customerId).then(res => {
                    const customerStatus = {id: customerId, data: res.data}
                    this.customerStatusList.push(customerStatus)
                })
            }
        },
        customOpenDialogEdit(customer) {
            let status = customer.customStatus
            if (status === 'In Progress') {
                this.$appService.toastWarning(this.$f.tc("warningEditInProgressCustomer"))
                this.loadData(1, false, false)
            } else {
                this.$refs.customerDialog.open(customer)
            }
        },
    },
    beforeDestroy() {
        this.customers = false
        this.tableKey = 0
        this.dataTable = []
        this.customerToDelete = false
        this.selectionData = []
    },
    watch: {
        timeRange: function () {
            let datetime = this.$refs.TimeRangePicker.getTimeRange()
            this.filter.from_date = datetime.fromDate
            this.filter.from_time = datetime.fromTime
            this.filter.to_date = datetime.toDate
            this.filter.to_time = datetime.toTime
            this.loadData(1, false, false)
        }
    }
}
</script>
<style scoped lang="scss">
.call-to-data {
    .call-to-actions {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;

        .btn-outline {
            margin-left: 6px;
            margin-bottom: 8px;

            &:first-child {
                margin-left: 0 !important;
            }
        }
    }

    .call-to-table-wrap {
        display: block;
        overflow: hidden;
        overflow-x: auto;
        width: 100%;
        border-width: 0 1px 1px 1px;
        border-style: solid;
        border-color: #96add0;
    }

    .call-to-table-data {
        display: block;
        width: auto;
        min-width: 1500px;
    }

    .customer-info {
        width: 50%;
        border: 1px solid #96add0;
        border-right: none;
        border-left: none;
    }

    .general-info {
        width: 50%;
        border: 1px solid #96add0;
        border-right: none;

        .general-info-btn {
            padding: 28px 0;
        }
    }
}

.img-hover {
    position: absolute;
}

.btn-delete {
    background: #dc3545 !important;
    color: #FFFFFF !important;
    border: 1px solid #dc3545 !important;

    &:hover {
        background: #dc3545bf !important;
        border: 1px solid #dc354500 !important;
    }
}


.btn-outline-delete {
    color: #dc3545 !important;
    border: 1px solid #dc3545 !important;

    &:hover {
        background: #ffabb3 !important;
        color: #dc3545 !important;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.icon-menu {
    border: 1px solid #d0d0d0;
    background: #f0f0f0;
    margin-left: 6px;
    cursor: pointer;
    height: 26px;
    width: 18px;
    border-radius: 4px;
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .fci-list-item {
        padding: 6px 12px !important;
        font-size: 14px;
    }

    .data-table .table-title {
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
    }

    .data-table .selection-actions .remove-selection {
        display: none;
    }
}

.step-actions {
    margin-top: 28px;

    .btn-custom {
        margin-left: 8px;

        &:first-child {
            margin-left: 0 !important;
        }
    }
}

.btn-disable {
    font-family: "open sans", serif !important;
}

@media screen and (min-width: 768px) {
    .call-to-data {
        .call-to-actions {
            text-align: right;
            padding: 32px 0 12px;

            button.v-btn {
                margin: 0 0 0 16px;
            }
        }
    }
}

@media screen and (max-width: 1199px) and (min-width: 600px) {
    .call-to-data {
        .call-to-actions {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-start;
            align-content: flex-start;
            margin: 0 0 5px;

            button.v-btn {
                width: calc(50% - 8px);
                margin: 0 0 16px;
            }
        }
    }
}

@media screen and (max-width: 599px) {
    .call-to-data {
        .call-to-actions {
            margin: 0 0 5px;

            button.v-btn {
                width: 100%;
                margin: 0 0 15px;
            }
        }
    }
}

@media screen and (min-width: 768px) {
    .customer-form-filter {
        .filter-form {
            .layout > .flex {
                width: 225px
            }

            button.v-btn {
                margin-left: 20px;
            }
        }
    }
}

@media screen and (min-width: 1024px) {
    .customer-form-filter {
        .filter-form {
            .layout > .flex {
                width: 275px
            }
        }
    }
}

@media screen and (max-width: 767px) {
    .customer-form-filter {
        flex-wrap: wrap;

        .filter-form {
            order: 0;
            flex-wrap: wrap;
            margin: 0;
            width: 100%;

            > .container {
                width: 100%;
            }

            .layout > .flex {
                width: 50%;
                margin: 0 0 20px;
            }

            button.v-btn {
                margin: 0;
                width: 100%;
            }
        }
    }
}

@media screen and (max-width: 520px) {
    .customer-form-filter {
        .filter-form {
            .layout > .flex {
                width: 100%;
            }
        }
    }
}

.additional-data {
    width: 100%;
    margin: 0;
    border-spacing: 0;
    border: 1px solid #96add0;
    border-radius: 5px;
    overflow: hidden;
    background: #fff;

    td {
        font-size: 13px;
        padding: 8px 12px;
    }

    thead {
        tr {
            background: #e4edfa;
            font-size: 13px;
            font-weight: bold;
            text-transform: uppercase;
        }
    }

    td, tr {
        border-top: 1px solid #96add0;
    }
}

.v-tooltip__content {
    color: black !important;
    padding: 6px;
}

.v-tooltip__content.menuable__content__active {
    opacity: 1 !important;
}

.action-icon-info {
    margin-left: 4px;
    color: #96ADD0;
}

.status-val {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    border-radius: 15px;
    color: #fff;
}
</style>
